// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"EditChannelSubscriptionForm_checkbox__1ViUw"};